<template>
  <NuxtPicture v-bind="props" />
</template>

<script setup lang="ts">
import type { PropType } from 'vue';
const props = defineProps({
  provider: {
    type: String as PropType<'sanity'>,
    required: true,
  },
  imgAttrs: {
    type: Object,
    required: false,
    default: () => {},
  },
  modifiers: {
    type: Object,
    required: false,
    default: () => {},
  },
  src: {
    type: String,
    required: true,
  },
  alt: {
    type: String,
    required: false,
    default: () => '',
  },
  // althought its common to use 'preload=true and loading='eager' for above-the-fold images,
  // everywhere else we use 'lazy' loading by default, and sometimes you want eager but NOT preload, when
  // its in the middle
  loading: {
    type: String as PropType<'lazy' | 'eager'>,
    required: false,
    default: 'lazy',
  },
  // see comment for loading above
  preload: {
    type: Boolean,
    required: false,
    default: false,
  },
});
</script>
